import { Component, Input, OnInit, ViewChild, OnChanges } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { AppTranslationService } from '../../services/app-translation.service';
import { AlertService, DialogType } from '../../services/alert.service';
import { CalendarRuleService } from "../../services/calendarrule.service";
import { CalRuleDlyProgService } from "../../services/calruledlyprog.service";
import { RsncdDlyProgService } from "../../services/rsncddlyprog.service";
import { CalendarRule } from '../../models/calendarrule.model';
import { DailyProgramService } from "../../services/dailyprogram.service";
import { WeekdayTypeService } from "../../services/weekdaytype.service";
import { DailyProgram } from '../../models/dailyprogram.model';
import { ReportParam } from '../../models/reportparam.model';
import { CalRuleDlyProg, CalRuleDlyProgColumns } from '../../models/calruledlyprog.model';
import { AuthService } from '../../services/auth.service';
import { LocalStoreManager } from '../../services/local-store-manager.service';
import { FixedList } from '../../models/fixedlist.model';
import { AbsenceCode } from '../../models/absencecode.model';
import { RsncdDlyProg, RsncdDlyProgProgColumns } from '../../models/rsncddlyprog.model';


@Component({
    selector: 'calendarrule',
    templateUrl: './calendarrule.component.html',
    styleUrls: ['./calendarrule.component.scss'],
    standalone: false
})
export class CalendarRuleComponent implements OnInit, OnChanges {
  @ViewChild('form', { static: true })

  public isNewCalendarRule = false;
  calendarRules: CalendarRule[] = [];
  dayprogs: DailyProgram[] = [];
  calendarRule: CalendarRule = null;
  displayedColumns: string[] = CalRuleDlyProgColumns.map((col) => col.key)
  columnsSchema: any = CalRuleDlyProgColumns
  dataSource = new MatTableDataSource<CalRuleDlyProg>();
  calRuleDlyProgs: CalRuleDlyProg[] = [];
  displayedColumns2: string[] = RsncdDlyProgProgColumns.map((col) => col.key)
  columnsSchema2: any = RsncdDlyProgProgColumns
  dataSource2 = new MatTableDataSource<RsncdDlyProg>();
  rscncdDlyprogs: RsncdDlyProg[] = [];
  weekdayTypes: FixedList[] = [];
  params = new ReportParam();
  filterQuery: string = null;
  currentIndex:number = 0; // Starts from the first record
  lastIndex = 0;
  isEdit: boolean = false;
  adding: boolean = false;
  valid: any = {};
  rights: number = 0;
  writeRights: number = 0;
  writeRight: boolean = false;

  @Input() isEditMode = true;

  searchForm: FormGroup;
  CalendarRuleForm: FormGroup;
  get searchName() {
    return this.searchForm.get('searchName');
  }

  get calrule_id() {
    return this.CalendarRuleForm.get('calrule_id');
  }

  get floatLabels(): string {
    return this.isEditMode ? 'auto' : 'always';
  }

  constructor(
    private alertService: AlertService,
    private authService: AuthService,
    private calendarRuleService: CalendarRuleService,
    private calRuleDlyProgService: CalRuleDlyProgService,
    private rsncdDlyProgService: RsncdDlyProgService,
    private dailyprogramService: DailyProgramService,
    private translationService: AppTranslationService,
    private weekdayTypeService: WeekdayTypeService,
    private formBuilder: FormBuilder,
    public localStorage: LocalStoreManager
  ) {
    this.searchForm = this.formBuilder.group({
      searchName: [''], // Initialize your search field
    });
    this.buildForm();
  }

  ngAfterViewInit() {
  }

  ngOnInit() {
    CalRuleDlyProgColumns[0].label = this.translationService.getTranslation('calRuleDlyprog.Dayprogram');
    CalRuleDlyProgColumns[1].label = this.translationService.getTranslation('common.Descr');
    CalRuleDlyProgColumns[2].label = this.translationService.getTranslation('calRuleDlyprog.ShifSelectBit');
    CalRuleDlyProgColumns[3].label = this.translationService.getTranslation('calRuleDlyprog.ReferenceSelect');
    CalRuleDlyProgColumns[4].label = this.translationService.getTranslation('calRuleDlyprog.SelectWeekDay');
    CalRuleDlyProgColumns[5].label = this.translationService.getTranslation('common.Descr');

    RsncdDlyProgProgColumns[0].label = this.translationService.getTranslation('stampcorrection.Reasoncode');
    RsncdDlyProgProgColumns[1].label = this.translationService.getTranslation('common.Descr');
    RsncdDlyProgProgColumns[2].label = this.translationService.getTranslation('stampcorrection.DayProgram');
    RsncdDlyProgProgColumns[3].label = this.translationService.getTranslation('common.Descr');

    this.dailyprogramService.getdailyprograms(this.params)
      .subscribe(data => {
        this.dayprogs = data;
      },
        (error: any) => {
          //console.log(error);
        });
    this.weekdayTypeService.getweekdays()
      .subscribe(data => {
        this.weekdayTypes = data;
      },
        (error: any) => {
          //console.log(error);
        });
    this.loadData();
    this.rights = this.localStorage.getDataObject("readrights");
    this.writeRights = this.localStorage.getDataObject("userrights");
    this.writeRight = (this.writeRights & 1024) == 1024;
  }

  clearSearchField(): void {
    this.searchForm.get('searchName').setValue(''); // This sets the searchName control to an empty string
  }

  loadData(query: string = null) {
    if (query) {
      this.filterQuery = query;
    }
    else
      this.filterQuery = this.searchForm.get('searchName').value === '' ? null : this.searchForm.get('searchName').value;
    this.calendarRuleService.getcalendarrulerelations(this.filterQuery)
      .subscribe(data => {
        this.calendarRules = data;
        if (this.calendarRules.length > 0) {
          this.calendarRule = this.calendarRules[this.currentIndex];
          this.lastIndex = this.calendarRules.length - 1;
          this.dataSource.data = this.calendarRules[this.currentIndex].calendarRuleDlyProgs;
          this.dataSource2.data = this.calendarRules[this.currentIndex].rsncdDlyProgs;
          this.updateFormValues();
        }
        else {
          var mess = this.translationService.getTranslation('notifications.NoDataAvailable');
          this.alertService.errorMessage(mess);
        }
        this.authService.refreshLogin()
          .subscribe(data => {
            this.authService.refresh_userdata(data);
          },
            (error: any) => {
            });
      },
        (error: any) => {
          //console.log(error);
        });
  }

  showNextRecord() {
    if (this.currentIndex < this.lastIndex) {
      this.currentIndex++;
      this.calendarRule = this.calendarRules[this.currentIndex];
      this.updateFormValues();
    }
  }

  showPreviousRecord() {
    if (this.currentIndex > 0) {
      this.currentIndex--;
      this.calendarRule = this.calendarRules[this.currentIndex];
      this.updateFormValues();
    }
  }

  showFirstRecord() {
    if (this.currentIndex > 0) {
      this.currentIndex = 0;
      this.calendarRule = this.calendarRules[this.currentIndex];
      this.updateFormValues();
    }
  }

  showLastRecord() {
    if (this.currentIndex < this.lastIndex) {
      this.currentIndex = this.lastIndex;
      this.calendarRule = this.calendarRules[this.currentIndex];
      this.updateFormValues();
    }
  }

  updateFormValues() {
    if (this.isNewCalendarRule) {
      this.resetForm();
    } else {
      const currentCalendarRule = this.calendarRules[this.currentIndex];
      this.CalendarRuleForm.patchValue({
        searchName: null,
        calrule_id: currentCalendarRule.calrule_id,
        descr: currentCalendarRule.descr,
        passivated: currentCalendarRule.passivated,
        automatic_copy_period: currentCalendarRule.automatic_copy_period
      });
      this.dataSource.data = currentCalendarRule.calendarRuleDlyProgs || [];
      this.dataSource2.data = currentCalendarRule.rsncdDlyProgs || [];
    }
  }

  ngOnChanges() {
    this.resetForm();
  }

  createCalendarRule() {
    this.isNewCalendarRule = true; 
    this.calendarRule = new CalendarRule(); 
    this.resetForm(); 
    this.clearFormFields();
    this.updateFormValues(); 
    this.currentIndex = 0;
  }

  public saveCalendarRule() {
    if (!this.CalendarRuleForm.valid) {
      this.alertService.errorMessage("Validation error");
      return;
    }
    var editedCalendarRule = this.getEditedCalendarRule();
    this.CalendarRuleForm.markAsPristine();

    if (this.isNewCalendarRule) {
      this.calendarRuleService.newCalendarRule(editedCalendarRule)
        .subscribe(id => {
          this.saveSuccessHelper(editedCalendarRule)
          this.isNewCalendarRule = false;
        },
          error => {
            if (error == "Unauthorized")
              this.authService.logout();
            else
              this.saveFailedHelper(error);
          });
    }
    this.searchForm.get('searchName').setValue(editedCalendarRule.descr);
    this.calendarRuleService.updateCalendarRule(editedCalendarRule).subscribe(
      response => this.saveSuccessHelper(editedCalendarRule),
      error => {
        if (error == "Unauthorized")
          this.authService.logout();
        else
          this.saveFailedHelper(error);
      });
    this.clearSearchField();
  }

  onInputChange(field: string, event: Event) {
    const value = (event.target as HTMLInputElement).value;
    this.CalendarRuleForm.markAsDirty();
  }

  private getEditedCalendarRule(): CalendarRule {
    const formModel = this.CalendarRuleForm.value;
    return {
      calrule_id: formModel.calrule_id,
      descr: formModel.descr,
      passivated: formModel.passivated,
      automatic_copy_period: formModel.automatic_copy_period,
      calendarRuleDlyProgs: null,
      rsncdDlyProgs: null
    };
  }

  private saveSuccessHelper(CalendarRule?: CalendarRule) {
    let mess: string;
    this.loadData();
    if (this.isNewCalendarRule) {
      mess = this.translationService.getTranslation('notifications.InsertRecordSucceeded');
    } else {
    mess = this.translationService.getTranslation('notifications.UpdateRecordSucceeded');
    }
    this.alertService.successMessage(mess);
  }

  private saveFailedHelper(CalendarRule?: CalendarRule) {
  }

  private buildForm() {
    this.CalendarRuleForm = this.formBuilder.group({
      calrule_id: null,
      descr: null,
      automatic_copy_period: null,
      passivated: null,
      saldoRelations:null
    });
  }

  private resetForm(stopEditing = false) {
    if (stopEditing) {
      this.isEditMode = false;
    }
    this.clearFormFields();
    this.CalendarRuleForm.reset({
      calrule_id: null,
      descr: null,
      automatic_copy_period: null,
      passivated: false,
      saldoRelations: null
    });

  }

  private clearFormFields() {
    this.dataSource.data = this.dataSource.data.map(item => ({
      ...item,
      calrule_id: null
    }));
    this.dataSource.data = [];
    this.dataSource2.data = this.dataSource2.data.map(item => ({
      ...item,
      calrule_id: null
    }));
    this.dataSource2.data = [];
  }

  public confirmDelete(calendarRule: CalendarRule) {
    let delQ = this.translationService.getTranslation('notifications.DeleteRecord');
    this.alertService.showDialog(delQ + '?',
      DialogType.confirm, () => this.deleteCalendarRule(calendarRule));
  }

  deleteCalendarRule(calendarRule: CalendarRule) {
    this.calendarRuleService.deleteCalendarRule(calendarRule.calrule_id)
      .subscribe(results => {
        var mess = this.translationService.getTranslation('notifications.DeleteRecordSucceeded');
        this.alertService.successMessage(mess);
        this.loadData();
      },
        error => {
        });
  }

  editRow(row: CalRuleDlyProg) {
    this.adding = false;
    let index = this.calendarRules.findIndex(x => x.calrule_id === row.calrule_id);
    row.calrule_id = this.calendarRule.calrule_id;
     if (row.id === -1) {
       this.calRuleDlyProgService.addCalruleDlyProg(row)
        .subscribe(response => {
          this.alertService.successMessage(this.translationService.getTranslation('notifications.CreateOk'));
          this.loadData();
        },
          error => {
            if (error == "Unauthorized")
              this.authService.logout();
            else
              this.loadData();
          });
    }
    else {
       this.calRuleDlyProgService.updateCalruleDlyProg(row)
        .subscribe(response => {
          this.alertService.successMessage(this.translationService.getTranslation('notifications.SaveOk'));
          this.loadData();
        },
          error => {
            if (error == "Unauthorized")
              this.authService.logout();
            else
              this.loadData();
          });
    }
  }

  editRow2(row: RsncdDlyProg) {
    this.adding = false;
    let index = this.calendarRules.findIndex(x => x.calrule_id === row.calrule_id);
    row.calrule_id = this.calendarRule.calrule_id;
    if (row.id === -1) {
      this.rsncdDlyProgService.addRsncdDlyProg(row)
        .subscribe(response => {
          this.alertService.successMessage(this.translationService.getTranslation('notifications.CreateOk'));
          this.loadData();
        },
          error => {
            if (error == "Unauthorized")
              this.authService.logout();
            else
              this.loadData();
          });
    }
    else {
      this.rsncdDlyProgService.updateRsncdDlyProg(row)
        .subscribe(response => {
          this.alertService.successMessage(this.translationService.getTranslation('notifications.SaveOk'));
          this.loadData();
        },
          error => {
            if (error == "Unauthorized")
              this.authService.logout();
            else
              this.loadData();
          });
    }
  }

  addRow() {
    this.adding = true;
    const newRow: CalRuleDlyProg = {
      id: -1,
      calrule_id: this.calendarRule.calrule_id,
      daily_prog_id: 0,
      dailyProgDescr: null,
      shift_select: null,
      reference_select: null,
      selectWeekdays: 0,
      weekDayDescr: null,
      isEdit: true,
    }
    this.dataSource.data = [newRow, ...this.dataSource.data]
  }

  addRow2() {
    this.adding = true;
    const newRow2: RsncdDlyProg = {
      id: -1,
      calrule_id: this.calendarRule.calrule_id,
      reasoncode_id: 0,
      reasoncodeDescr: null,
      dailyprog_id: 0,
      dailyprogDescr: null,
      isEdit: true,
    }
    this.dataSource2.data = [newRow2, ...this.dataSource2.data]
  }


  inputHandler(e: any, id: number, key: string) {
    if (!this.valid[id]) {
      this.valid[id] = {}
    }
    this.valid[id][key] = e.target.validity.valid
  }

  disableSubmit(id: number) {
    if (this.valid[id]) {
      return Object.values(this.valid[id]).some((item) => item === false)
    }
    return false
  }

  confirmDeleteCalRuleDailyProg(row: CalRuleDlyProg) {
    this.calRuleDlyProgService.deleteCalruleDlyProg(this.calrule_id.value, row.daily_prog_id)
      .subscribe(results => {
        this.alertService.successMessage(this.translationService.getTranslation('notifications.DeleteOk'));
        this.loadData();
      },
        error => {
        });
  }

  confirmDeleteCalRuleAbsenceCode(row: RsncdDlyProg) {
    this.calRuleDlyProgService.deleteCalruleDlyProg(this.calrule_id.value, row.reasoncode_id)
      .subscribe(results => {
        this.alertService.successMessage(this.translationService.getTranslation('notifications.DeleteOk'));
        this.loadData();
      },
        error => {
        });
  }

  cancelCalendar() {
  }

  cancel(): void {
    this.isNewCalendarRule = false; 
    this.resetForm();
    this.calendarRule = this.calendarRules[this.currentIndex];
    this.updateFormValues();
    this.loadData();
  }

  get canManageCalendarRule() {
    return true; //this.accountService.userHasPermission(Permission.manageRolesPermission);
  }
}

 


